/**
 * @category Custom Errors
 */
export enum ErrorCodes {
  'alphabetical-chars-only' = 'alphabetical-chars-only',
  'is-not-a-boolean' = 'is-not-a-boolean',
  'is-empty' = 'is-empty',
  'is-not-a-number' = 'is-not-a-number',
  'does-not-match-enum' = 'does-not-match-enum',
  'chars-limit-exceeded' = 'chars-limit-exceeded',
  'chars-lenght-is-too-short' = 'chars-lenght-is-too-short',
  'is-not-an-array' = 'is-not-an-array',
  'failed-custom-validate' = 'failed-custom-validate'
}
